import InputPasswordField01 from 'app/common/components/Form/Fields/Common/InputPasswordField01/InputPasswordField01';
export default InputPasswordField01;
